import { render, staticRenderFns } from "./Autopsy.vue?vue&type=template&id=86c6c258&"
import script from "./Autopsy.vue?vue&type=script&lang=js&"
export * from "./Autopsy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports